import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import SydModal from '../../../../../commonDesign/SydModal'
import ChangeDatasourceSchemaForm from './form'

const ChangeDatasourceSchemaDialog = React.forwardRef(function ChangeDatasourceSchemaDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: (dataSource) => setDialogState({
      open: true,
      processing: false,
      dataSource
    })
  }), [setDialogState])

  return (
    <SydModal
      title='Change Datasource Schema'
      open={dialogState.open}
      onClose={close}
      size='md'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <ChangeDatasourceSchemaForm
            dataSource={dialogState.dataSource}
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </SydModal>
  )
})

ChangeDatasourceSchemaDialog.propTypes = {
  onComplete: PropTypes.func
}

ChangeDatasourceSchemaDialog.defaultProps = {
  onComplete: () => {}
}

export default ChangeDatasourceSchemaDialog
